@let edgeStatus = selectEdgeStatus$|async;
@let metadata = edgeStatus?.metadata;
@let DetectionMethod = AddCameraWizardModels.DetectionMethod;
<div class="wizard-scan-selection p-r w-100">
    <div class="flex-col flex gap-24 w-100">
        @if (detectionMethod === DetectionMethod.CsvImport) {
        <div class="csv-import">
            <div class="csv-import-header flex-row space-between-center">
                <div class="csv-import-title">{{ 'ADD_CAMERA_WIZARD.CSV.UPLOAD_TITLE'|translate }}</div>
                <ui-button type="secondary" [text]="'ADD_CAMERA_WIZARD.CSV.DOWNLOAD_EXAMPLE'|translate" (clickAction)="downloadExampleCsv()"></ui-button>
            </div>
            <div class="csv-import-description">{{ 'ADD_CAMERA_WIZARD.CSV.UPLOAD_DESCRIPTION'|translate }}</div>

            @if (!csvImportedRows.length) {
            <div class="csv-upload-zone flex-col center-center gap-16"
                [class.has-error]="csvParseErrors.length"
                appDragDropFileUpload
                (fileDropped)="onCsvFileDropped($event)">
                <span class="ui-icon-upload"></span>
                <div class="csv-upload-text">{{ 'ADD_CAMERA_WIZARD.CSV.DRAG_DROP'|translate }}</div>
                <ui-button type="primary" [text]="'ADD_CAMERA_WIZARD.CSV.BROWSE'|translate" (clickAction)="csvFileInput.click()"></ui-button>
            </div>
            } @else {
            <div class="csv-import-summary flex-row space-between-center">
                <div class="flex-row start-center gap-8">
                    <span class="ui-icon-status-online csv-import-success-icon"></span>
                    <span>{{ 'ADD_CAMERA_WIZARD.CSV.IMPORTED_COUNT'|translate:{ count: csvImportedRows.length, file: csvFileName } }}</span>
                </div>
                <ui-button type="secondary" [text]="'ADD_CAMERA_WIZARD.CSV.REPLACE_FILE'|translate" (clickAction)="clearCsvImport()"></ui-button>
            </div>
            }

            @if (csvParseErrors.length) {
            <div class="csv-error-list">
                @for (error of csvParseErrors; track error) {
                <div class="csv-error-item">{{ formatCsvError(error) }}</div>
                }
            </div>
            }

            <input #csvFileInput type="file" hidden accept=".csv,text/csv" (change)="onCsvFileSelected($event)" />
        </div>
        } @else if (detectionMethod === DetectionMethod.Manual) {
        <div class="manual-selection">
            <div class="manual-title">{{ 'ADD_CAMERA_WIZARD.MANUAL.DEVICE_TYPE'|translate }}</div>
            <div class="device-type-row" [formGroup]="manualForm">
                <label class="device-type-card flex-row space-between-center">
                  <div class="flex-row start-center gap-16">
                    <input type="radio" [value]="'camera'" formControlName="deviceType" />
                    <div class="device-type-content ">
                        <div class="device-type-name">{{ 'COMMON.CAMERA'|translate }}</div>
                    </div>
                  </div>
                  <span class="ui-icon-camera"></span>
                </label>
                <label class="device-type-card flex-row space-between-center">
                  <div class="flex-row start-center gap-16">
                    <input type="radio" [value]="'nvr'" formControlName="deviceType" />
                    <div class="device-type-content">
                        <div class="device-type-name">{{ 'ADD_CAMERA_WIZARD.MANUAL.NVR'|translate }}</div>
                    </div>
                  </div>
                  <span class="ui-icon-nvr"></span>
                </label>
            </div>
            <div class="vertical-divider">&nbsp;</div>
            <div class="manual-title">{{ 'ADD_CAMERA_WIZARD.MANUAL.IP_ADDRESS'|translate }}</div>
            <div class="manual-ip-list">
                <div class="manual-ip-row" *ngFor="let ctrl of manualIps.controls; let i = index">
                    <input class="ui-input ui-input-40" type="text" [formControl]="$any(ctrl)" [placeholder]="'ADD_CAMERA_WIZARD.MANUAL.IP_PLACEHOLDER'|translate" />
                    <button type="button" class="ip-action-btn" (click)="removeManualIp(i)" [disabled]="manualIps.length <= 1">
                        <span class="ui-icon-delete"></span>
                    </button>
                </div>
            </div>
            <button type="button" class="add-ip-btn" (click)="addManualIp()" *ngIf="manualForm?.get('deviceType')?.value !== 'nvr'">
                <span class="ui-icon-plus"></span>
                {{ 'ADD_CAMERA_WIZARD.MANUAL.ADD_IP'|translate }}
            </button>
        </div>
        } @else {
        <!-- Progress Bar (during scan) -->
        <div class="progress">
          @if (progressDone) {
            <div class="select-label">{{ 'ADD_CAMERA_WIZARD.SCAN.SELECT_CAMERAS_TO_AUTH'|translate }}</div>
          } @else {
            <div class="flex-row center-center w-100">
                <div class="p-r w-100 progress-wrapper">
                    <div class="progress-wrapper-inner">
                        <mat-progress-bar class="w-100" mode="determinate" [value]="scanProgress"></mat-progress-bar>
                    </div>
                    <div class="progress-background"></div>
                </div>
                <div class="progress-percent">{{ scanProgress }}%</div>
                <div *ngIf="scanProgress === 100">
                    <span class="ui-icon-check_in_green"></span>
                </div>
            </div>
          }
        </div>

        <!-- Filter Dropdown, Search and Camera Count -->
        <div class="flex-row space-between-center">
            <div class="flex-row start-center gap-8">
                <mat-form-field appearance="outline" class="filter-select">
                    <mat-select [(ngModel)]="filterTypes" multiple>
                        <mat-option *ngFor="let filter of availableFilters" [value]="filter.value">
                            {{ filter.label | translate }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <input
                  class="ui-input ui-input-40 search-input"
                  type="text"
                  [formControl]="searchControl"
                  [placeholder]="'ADD_CAMERA_WIZARD.SCAN.SEARCH_PLACEHOLDER' | translate"
                />
            </div>
          @if (isLegacy(metadata)) {
            <ui-button type="default" (clickAction)="manual()">
              {{'CAMERA_CREATE.BUTTONS.ADD_MANUALLY'|translate}}
            </ui-button>
          } @else {
            <div class="camera-count">{{ 'ADD_CAMERA_WIZARD.SCAN.CAMERAS_FOUND'|translate:{count: discoveredCameras.length} }}</div>
          }
        </div>

        <!-- Camera Table -->
        <div class="tables-container" *ngIf="discoveredCameras.length > 0">

            <app-camera-table [edgeId]="edgeId" [dataSourceInput]="discoveredCameras" [filteredInput]="filteredCameras" [query]="searchControl.value"
                [displayedColumns]="displayedColumns" [multiSelect]="!isLegacy(metadata)" [types]="filterTypes"
                              [isLegacy]="isLegacy(metadata)"
                [name]="'CAMERA_SELECT_TAB.TABLE_NAME.ONLINE_CAMERAS'|translate" (camerasAdded)="onCameraToggled($event)">
            </app-camera-table>
        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="!isScanning && discoveredCameras.length === 0">
            <div class="empty-icon">📷</div>
            <div class="empty-title">{{ 'ADD_CAMERA_WIZARD.SCAN.EMPTY.TITLE'|translate }}</div>
            <div class="empty-description">{{ 'ADD_CAMERA_WIZARD.SCAN.EMPTY.DESCRIPTION'|translate }}</div>
        </div>
        }
    </div>
</div>